// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__eWuOZ","text":"Loading_text__heC-P","line":"Loading_line__rBcEM","hide":"Loading_hide__fHUMl"};